import AbstractAlert from "./AbstractAlert.js";

/**
 * An alert representing something that went well.
 */
export default class SuccessAlert extends AbstractAlert {}
